/**
 * This file contains content type descriptors that are used to map process data accordion to the content type in processListObjects.
 * Its also used to map content type to correct card in `ListSearchResultsCardSelector`.
 * Expand this if adding more cards or content types to be displayed in part List or ListSearch
 */
export const contentTypeCardMap = {
  normerende: [
    "helsedirektoratet:ehelsestandard",
    "helsedirektoratet:faglig-rad",
    "helsedirektoratet:generisk-produkt",
    "helsedirektoratet:nasjonalt-forlop",
    "helsedirektoratet:normen-dokument",
    "helsedirektoratet:retningslinje",
    "helsedirektoratet:rundskriv-edit",
    "helsedirektoratet:veileder"
  ],
  lovfortolkning: [
    "helsedirektoratet:lovfortolkning",
    "helsedirektoratet:veileder",
    "helsedirektoratet:rundskriv-edit"
  ],
  displayContentType: [
    "helsedirektoratet:brosjyre",
    "helsedirektoratet:statistikkvisning",
    "helsedirektoratet:statistikkelement"
  ],
  displayWithContentTypeAndDate: [
    "helsedirektoratet:horing",
    "helsedirektoratet:nyhet",
    "helsedirektoratet:rapport"
  ],
  displayWithPreface: [
  ],
  event: [
    "helsedirektoratet:arrangement",
    "helsedirektoratet:helsecoreEvent"
  ],
  tilskudd: ["helsedirektoratet:tilskudd"]
};
